export default "__VITE_ASSET__aed2649f__"